import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { isPortrait } from '../utils/size';

const Group = styled.div`
    flex: 1;
    display: flex;
    flex-direction: row;
    margin-top: ${props => (props.marginTop ? props.marginTop : '0')};

    ${props =>
        props.noBack &&
        `
            justify-content: flex-end !important;
            button {
                margin-right: 0 !important;
            }
    `};

    > button:first-child,
    > div:first-child,
    .middleButton {
        margin-right: 0.5em;
        max-width: 50%;
    }

    button:last-child,
    > button:last-child,
    > div:last-child {
        margin-left: 0.5em;
    }

    ${props =>
        props.fullWidth &&
        `
        button {
            ${!isPortrait() ? `margin-left: 0.5em;` : ''}
            max-width: 100% !important;
        }`};
`;

const TwoGroup = props => <Group {...props} className="ie-two-group">{props.children}</Group>;

TwoGroup.propTypes = {
    children: PropTypes.array.isRequired,
    fullWidth: PropTypes.bool
};

export default TwoGroup;
